import styles from './styles.module.scss';

type PageLayoutProps = {
  children: React.ReactNode;
};

export const PageLayout = ({ children }: PageLayoutProps) => {
  return <div className={styles['pageContent']}>{children}</div>;
};
